import React from "react";

export const ExchangeIcon = ({ variant }) => {
  if (variant === "white")
    return (
      <img
        src={require("../../assets/img/icons/interface/exchange-alt.png")}
        style={{
          width: "12px",
          height: "12px",
          cursor: "pointer",
          marginLeft: "0px",
        }}
        alt="icone"
      />
    );

  return (
    <img
      src={require("../../assets/img/icons/interface/exchange-black.png")}
      style={{
        width: "12px",
        height: "12px",
        cursor: "pointer",
        marginLeft: "5px",
      }}
      alt="icone"
    />
  );
};
